<template>
  <div
    tabindex="0"
    @click="toggleFavorite"
    @keyup.enter="toggleFavorite"
    role="link"
    :aria-label="'Press enter to ' + (on ? 'save this property to' : 'remove this property from') + ' your favorites'"
    :class="{ 'text-error bg-opacity-100': on, 'text-white/50': !on }"
  >
    <span :class="'text-' + offColor" v-if="offText != '' && !on">{{ offText }}</span>
    <span :class="'text-' + onColor" v-if="onText != '' && on">{{ onText }}</span>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: "FavoriteButton",

  props: {
    mls: {
      type: String,
      default: ''
    },
    onText: {
      type: String,
      default: ''
    },
    offText: {
      type: String,
      default: ''
    },
    onColor: {
      type: String,
      default: ''
    },
    offColor: {
      type: String,
      default: ''
    },
    loggedIn: {
      type: Boolean,
      default: false
    },
    user: {
      type: Number,
      default: null
    }
  },

  data: () => ({
    on: false
  }),

  mounted () {
    this.on = JSON.parse(localStorage.getItem('favorites')).includes(this.mls)
  },

  methods: {
    toggleFavorite () {
      let favorites = [];

      //get olds values
      favorites = JSON.parse(localStorage.getItem('favorites'));

      if(favorites.includes(this.mls)){
        const index = favorites.indexOf(this.mls);
        if (index > -1) {
          favorites.splice(index, 1);
        }
      }else{
        favorites.push(this.mls);
      }

      //saved values
      localStorage.setItem('favorites', JSON.stringify(favorites));

      this.on = !this.on

      // If user is logged in and user ID is set, save to DB
      if(this.loggedIn && !isNaN(this.user) && this.user !== 0 ){
        this.sendToDb()
      }

      this.$emit('changed')

      if(this.on) {
        dataLayer.push({
          'event': 'user_action',
          'action_name': 'Favorite',
          'mls_account': this.mls,
        })
      }
    },

    sendToDb () {

      let action = this.on ? 'add' : 'remove'

      fetch('/wp-json/kerigansolutions/v1/handlefavorite?user_id=' + this.user + '&mls_account=' + this.mls + '&action=' + action, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(r => r.json())
        .then((res) => {
          console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
    }

  }
}
</script>
